module.exports = __webpack_public_path__ + "static/our-story-1-6a706fc591168ba13803f6932f9c79f2.webp";